import { Reducer } from 'redux';
import { GetStackResponse, FieldResponse } from '../.generated/api';

export const UPDATE_STACK = 'UPDATE_STACK';
export const STACK_ERROR = 'STACK_ERROR';

export interface StackSection {
  title: Record<string, string>;
  fields: Array<FieldResponse>;
}

export interface StackState {
  sections?: StackSection[];
  stack?: GetStackResponse;
}

export interface UpdateStack {
  type: typeof UPDATE_STACK;
  stack?: GetStackResponse;
}
export interface StackError {
  type: typeof STACK_ERROR;
}

// do some pre processing before saving to stack state
function stackStateFromResponse(stackResponse: GetStackResponse): StackState {
  // build field map and set values
  // TODO: field values may be removed in the future, so values should be forwarded separately.
  const fieldMap: Record<string, FieldResponse> = {};
  const values = stackResponse?.values ?? {};
  stackResponse?.measurementCard?.fields?.forEach((field) => {
    if (field.id) {
      field.defaultValue = values[field.id];
      fieldMap[field.id] = field;
    }
  });

  // build sections from display configuration and field map
  const sections: StackSection[] = [];
  stackResponse?.measurementCard?.displayConfigurationAdmin?.sections?.forEach(
    (displaySection) => {
      const fields: FieldResponse[] = [];
      for (const fieldId of displaySection.fields) {
        const field = fieldMap[fieldId];
        const value = values[fieldId];
        if (field && value != null) {
          fields.push(field);
        }
      }
      if (fields.length > 0) {
        sections.push({
          title: displaySection.title,
          fields: fields,
        });
      }
    },
  );

  return {
    sections: sections,
    stack: stackResponse,
  };
}

type StackActionTypes = UpdateStack | StackError;

const stackReducer: Reducer<StackState, StackActionTypes> = (
  state: StackState | undefined,
  incomingAction: StackActionTypes,
): StackState => {
  if (state === undefined) {
    return {};
  }
  switch (incomingAction.type) {
    case UPDATE_STACK:
      return incomingAction.stack
        ? stackStateFromResponse(incomingAction.stack)
        : {};
    case STACK_ERROR:
      return {
        sections: [],
      };
    default:
      return state;
  }
};

export { stackReducer };
